import type { ExpenseCategory } from "@/store/global";
import { useMutation } from "@tanstack/react-query";
import axios from "axios";

export const syncCategoriesMutation = (categories: ExpenseCategory[]) => {
  return useMutation({
    mutationKey: ["syncCategories"],
    mutationFn: () => axios.patch("/api/categories", { categories }),
    onError: (error) => {
      console.error("Error updating categories:", error);
    },
  });
};
